(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-about"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var els = document.querySelectorAll('[data-about-reveal]');
  if (!els.length) return;
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (mq && mq.matches) {
    els.forEach(function (el) { el.classList.add('zt-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('zt-visible');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (el) { io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-ambassadrice"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // Reveals
  var revealEls = document.querySelectorAll('[data-amb-reveal]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // Accordions FAQ ambassadrice
  var acc = document.querySelectorAll('.zt-amb-acc-panel');
  acc.forEach(function (panel) {
    var btn = panel.previousElementSibling;
    if (!btn) return;
    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        panel.style.height = panel.scrollHeight + 'px';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { panel.style.height = '0'; });
        });
        btn.setAttribute('aria-expanded', 'false');
      } else {
        panel.style.height = panel.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
        panel.addEventListener('transitionend', function onEnd() {
          panel.style.height = 'auto';
          panel.removeEventListener('transitionend', onEnd);
        });
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-avis"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var els = document.querySelectorAll('[data-avis-reveal]');
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (e) { e.classList.add('is-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  els.forEach(function (el) { io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // ── Reveals ────────────────────────────────────────────────
  var reveals = document.querySelectorAll('[data-faq-reveal]');
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reveals.length) {
    if (mq && mq.matches) {
      reveals.forEach(function (el) { el.classList.add('zt-visible'); });
    } else {
      var rio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('zt-visible'); rio.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -6% 0px' });
      reveals.forEach(function (el) { rio.observe(el); });
    }
  }

  // ── Accordéon (scrollHeight — BRIEF §4.1) ─────────────────
  var allFaqBtns = document.querySelectorAll('[data-faq-toggle]');
  allFaqBtns.forEach(function (btn) {
    var panelId = btn.getAttribute('data-faq-toggle');
    var panel = document.getElementById(panelId);
    if (!panel) return;
    panel.removeAttribute('hidden');

    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';

      /* Close all other open panels */
      allFaqBtns.forEach(function (otherBtn) {
        if (otherBtn === btn) return;
        if (otherBtn.getAttribute('aria-expanded') !== 'true') return;
        var otherId = otherBtn.getAttribute('data-faq-toggle');
        var otherPanel = document.getElementById(otherId);
        if (!otherPanel) return;
        otherPanel.style.height = otherPanel.scrollHeight + 'px';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { otherPanel.style.height = '0'; });
        });
        otherBtn.setAttribute('aria-expanded', 'false');
      });

      if (isOpen) {
        panel.style.height = panel.scrollHeight + 'px';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { panel.style.height = '0'; });
        });
        btn.setAttribute('aria-expanded', 'false');
      } else {
        panel.style.height = panel.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
        panel.addEventListener('transitionend', function onEnd() {
          panel.style.height = 'auto';
          panel.removeEventListener('transitionend', onEnd);
        });
      }
    });
  });

  // ── Active category chip (IntersectionObserver) ────────────
  var chips = document.querySelectorAll('[data-faq-chip]');
  var cats  = document.querySelectorAll('[data-faq-cat]');
  if (cats.length && chips.length) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var id = e.target.getAttribute('data-faq-cat');
          chips.forEach(function (chip) {
            var active = chip.getAttribute('data-faq-chip') === id;
            chip.setAttribute('aria-current', active ? 'true' : 'false');
          });
        }
      });
    }, { rootMargin: '-150px 0px -65% 0px' });
    cats.forEach(function (cat) { cio.observe(cat); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-legal"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var sections = document.querySelectorAll('.zt-legal-section');
  var links    = document.querySelectorAll('.zt-legal-toc__link');
  if (!sections.length || !links.length || !('IntersectionObserver' in window)) return;

  function setActive(id) {
    links.forEach(function (l) {
      l.classList.toggle('zt-legal-toc__link--active', l.getAttribute('data-toc-target') === id);
    });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) setActive(e.target.id);
    });
  }, { rootMargin: '-10% 0px -78% 0px', threshold: 0 });

  sections.forEach(function (s) { io.observe(s); });
  if (sections.length > 0) setActive(sections[0].id);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-quiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // Contenu du quiz (questions/résultats/UI) externalisé via l'îlot JSON rendu
  // par Liquid (#zt-qz-content) → traduisible dans Translate & Adapt. Les `tag`
  // sont de la logique (jamais traduits). Fallback : quiz vide si l'îlot manque.
  // Le filtre Liquid `t` échappe les entités HTML (l&#39;…). Correct en HTML mais
  // pas quand on lit l'îlot en JSON puis via textContent → on décode récursivement.
  function _qzDec(s) { var t = document.createElement('textarea'); t.innerHTML = s; return t.value; }
  function _qzDeep(o) {
    if (typeof o === 'string') return _qzDec(o);
    if (Array.isArray(o)) return o.map(_qzDeep);
    if (o && typeof o === 'object') { var r = {}; for (var k in o) r[k] = _qzDeep(o[k]); return r; }
    return o;
  }
  var QZC = { questions: [], results: {}, ui: {} };
  try {
    var _qzc = document.getElementById('zt-qz-content');
    if (_qzc) QZC = _qzDeep(JSON.parse(_qzc.textContent));
  } catch (e) { console.warn('[Zentira] quiz: contenu i18n illisible:', e); }
  var QUESTIONS = QZC.questions || [];
  var RESULTS   = QZC.results || {};
  var UI        = QZC.ui || {};

  // State
  var state = { step: 'intro', qi: 0, answers: [null, null, null, null, null], consent: false, codeUnlocked: false };

  // DOM refs
  var panes = {
    intro:    document.getElementById('zt-qz-intro'),
    question: document.getElementById('zt-qz-question'),
    email:    document.getElementById('zt-qz-email'),
    result:   document.getElementById('zt-qz-result'),
  };
  var progressRow  = document.getElementById('zt-qz-progress-row');
  var progressFill = document.getElementById('zt-qz-fill');
  var progressLbl  = document.getElementById('zt-qz-prog-label');
  var qNum   = document.getElementById('zt-qz-num');
  var qText  = document.getElementById('zt-qz-text');
  var qOpts  = document.getElementById('zt-qz-opts');
  var resTag      = document.getElementById('zt-qz-res-tag');
  var resHeading  = document.getElementById('zt-qz-res-heading');
  var resText     = document.getElementById('zt-qz-res-text');
  var resTip      = document.getElementById('zt-qz-tip');
  var codeBanner  = document.getElementById('zt-qz-code-banner');
  var consentCheck = document.getElementById('zt-qz-consent-check');
  var resFormat       = document.getElementById('zt-qz-res-format');
  var resFormatName   = document.getElementById('zt-qz-res-format-name');
  var resFormatReason = document.getElementById('zt-qz-res-format-reason');
  var ctaLink         = document.getElementById('zt-qz-cta');
  var emailInput      = document.getElementById('zt-qz-email-input');
  var emailErr        = document.getElementById('zt-qz-email-err');

  // Variantes réelles (id/titre/url) injectées par Liquid — pour recommander un
  // format concret et lier vers la bonne variante (?variant=…).
  var VARIANTS = [];
  try {
    var vdata = document.getElementById('zt-qz-variants-data');
    if (vdata) VARIANTS = JSON.parse(vdata.textContent || '[]');
  } catch (e) { console.warn('[Zentira] quiz: parsing des variantes échoué:', e); }

  // Un flacon dure ~1 mois → la reco de format suit la durée de routine (Q5).
  var FORMAT_REASONS = UI.reasons || [];
  function recommendFormat() {
    var a4 = state.answers[4];   // « Ton rythme idéal ? »
    if (a4 === 2) return 0;      // « Le moins d'étapes possible » → 1 flacon
    if (a4 === 3) return 2;      // « J'aime prendre le temps »    → 3 flacons
    return 1;                    // défaut                          → 2 flacons
  }

  function showPane(name) {
    Object.keys(panes).forEach(function (k) {
      var el = panes[k];
      el.classList.toggle('zt-quiz-pane--active', k === name);
    });
  }

  function updateProgress() {
    var inQ    = (state.step === 'question');
    var inMail = (state.step === 'email');
    progressRow.style.display = (inQ || inMail) ? 'flex' : 'none';
    if (inQ) {
      var pct = Math.round(((state.qi + 1) / (QUESTIONS.length + 1)) * 100);
      progressFill.style.width = pct + '%';
      progressLbl.textContent  = (UI.qshort || 'Q') + ' ' + (state.qi + 1) + ' / ' + QUESTIONS.length;
    } else if (inMail) {
      progressFill.style.width = '100%';
      progressLbl.textContent  = UI.almost || '';
    }
  }

  function renderQuestion() {
    var q = QUESTIONS[state.qi];
    qNum.textContent  = (UI.question || 'Question') + ' ' + (state.qi + 1) + ' / ' + QUESTIONS.length;
    qText.textContent = q.text;
    qOpts.setAttribute('aria-label', q.text);
    qOpts.innerHTML   = '';
    q.options.forEach(function (opt, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'zt-quiz-opt' + (state.answers[state.qi] === i ? ' zt-quiz-opt--selected' : '');
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', state.answers[state.qi] === i ? 'true' : 'false');
      btn.innerHTML =
        '<span class="zt-quiz-dot"><span class="zt-quiz-dot__inner"></span></span>' +
        '<span>' + opt.label + '</span>';
      btn.addEventListener('click', function () {
        state.answers[state.qi] = i;
        renderQuestion();
      });
      qOpts.appendChild(btn);
    });
    var nextBtn = document.getElementById('zt-qz-next');
    var noAnswer = state.answers[state.qi] === null;
    nextBtn.disabled = noAnswer;
    nextBtn.style.opacity    = noAnswer ? '0.45' : '1';
    nextBtn.style.cursor     = noAnswer ? 'not-allowed' : 'pointer';
    nextBtn.style.background = noAnswer ? '#C9C5BC' : '';
    var isLast = state.qi === QUESTIONS.length - 1;
    nextBtn.querySelector('span').textContent = isLast ? (UI.finish || 'Terminer') : (UI.next || 'Suivant');
  }

  function computeResult() {
    var counts = {};
    state.answers.forEach(function (ai, qi) {
      if (ai === null) return;
      var tag = QUESTIONS[qi].options[ai].tag;
      if (tag === 'sensitive' || tag === 'none') return;
      counts[tag] = (counts[tag] || 0) + 1;
    });
    var best = 'dull', bestN = -1;
    ['dull', 'dry', 'rough', 'maintain'].forEach(function (k) {
      if ((counts[k] || 0) > bestN) { best = k; bestN = counts[k] || 0; }
    });
    var sensitive = state.answers[3] !== null &&
      QUESTIONS[3].options[state.answers[3]].tag === 'sensitive';
    return { key: best, sensitive: sensitive };
  }

  function showResult() {
    var res = computeResult();
    var r   = RESULTS[res.key];
    resTag.textContent     = r.tag;
    resHeading.textContent = r.heading;
    resText.textContent    = r.text;
    resTip.style.display   = res.sensitive ? 'flex' : 'none';
    if (codeBanner) codeBanner.style.display = state.codeUnlocked ? 'flex' : 'none';

    // Reco de format + lien vers la bonne variante
    var fi = recommendFormat();
    if (VARIANTS.length && VARIANTS[fi]) {
      var vv = VARIANTS[fi];
      if (resFormatName)   resFormatName.textContent   = vv.title;
      if (resFormatReason) resFormatReason.textContent = FORMAT_REASONS[fi] || '';
      if (resFormat)       resFormat.style.display     = 'flex';
      if (ctaLink && vv.url) ctaLink.href = vv.url;
    } else if (resFormat) {
      resFormat.style.display = 'none';
    }

    goTo('result');
  }

  function goTo(step) {
    state.step = step;
    showPane(step);
    updateProgress();
    if (step === 'question') renderQuestion();
  }

  // Events
  document.getElementById('zt-qz-start').addEventListener('click', function () {
    state.qi = 0;
    goTo('question');
  });

  document.getElementById('zt-qz-next').addEventListener('click', function () {
    if (state.answers[state.qi] === null) return;
    if (state.qi < QUESTIONS.length - 1) {
      state.qi++;
      goTo('question');
    } else {
      goTo('email');
    }
  });

  document.getElementById('zt-qz-back').addEventListener('click', function () {
    if (state.qi > 0) { state.qi--; goTo('question'); }
    else               { goTo('intro'); }
  });

  // #zt-qz-submit-email est un submit natif du form client Shopify (token CAPTCHA
  // inclus → écrit vraiment le client + consentement marketing + tag quiz). On
  // sauvegarde l'état avant le rechargement pour restaurer directement le résultat.
  var qform = document.getElementById('zt-qz-form');
  if (qform) {
    qform.addEventListener('submit', function () {
      try { sessionStorage.setItem('zt-qz-restore', JSON.stringify({ answers: state.answers })); }
      catch (e) { console.warn('[Zentira] quiz: sessionStorage indisponible:', e); }
      // Tag du client Shopify = quiz + format recommandé (segmentation).
      try {
        var fi = recommendFormat();
        var tagsInput = qform.querySelector('input[name="contact[tags]"]');
        if (tagsInput) {
          var extra = ['format-' + (fi + 1)]; // format-1/2/3, indépendant de la langue (D2.4)
          state.answers.forEach(function (ai, qi) { // une réponse = un tag (D2.3)
            if (ai != null && QUESTIONS[qi] && QUESTIONS[qi].options[ai]) {
              var qkey = QUESTIONS[qi].key || ('q' + (qi + 1));
              var atag = QUESTIONS[qi].options[ai].tag;
              if (atag) extra.push('quiz-' + qkey + '-' + atag);
            }
          });
          // conserve la base rendue par Liquid (quiz,newsletter,source-quiz,market-*)
          tagsInput.value = tagsInput.value + ',' + extra.join(',');
        }
      } catch (e) { console.warn('[Zentira] quiz: tags non ajoutés:', e); }
    });
  }
  document.getElementById('zt-qz-skip-email').addEventListener('click', function () {
    state.codeUnlocked = false;
    showResult();
  });
  document.getElementById('zt-qz-restart').addEventListener('click', function () {
    state = { step: 'intro', qi: 0, answers: [null, null, null, null, null], consent: false, codeUnlocked: false };
    if (consentCheck) consentCheck.checked = false;
    goTo('intro');
  });

  if (consentCheck) {
    consentCheck.addEventListener('change', function () {
      state.consent = consentCheck.checked;
    });
  }

  // Init — si on revient d'une soumission email réussie, restaure le résultat.
  var restored = false;
  if (window.ztQuizPosted) {
    try {
      var saved = JSON.parse(sessionStorage.getItem('zt-qz-restore') || 'null');
      if (saved && Array.isArray(saved.answers)) {
        state.answers = saved.answers;
        state.codeUnlocked = true;
        sessionStorage.removeItem('zt-qz-restore');
        showResult();
        restored = true;
      }
    } catch (e) { console.warn('[Zentira] quiz: restauration du résultat échouée:', e); }
  }
  if (!restored) {
    showPane('intro');
    updateProgress();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
